<template>
  <div class="custom-report-page" :style="pageStyle">
    <!-- <navbar /> -->
    <div class="custom-report-container" :style="containerStyle">
      <template v-for="(section, index) in templates">
        <div v-if="!isSectionHidden(index)" :key="index" :class="{ 'a4-page': isPage, 'cover-page': isCoverPage(index) }">
          <div v-if="isPage && !isCoverPage(index)" class="page-header">
            <div class="header-content">
              <div class="header-left">{{ headerLeft }}</div>
              <div class="header-center">{{ headerCenter }}</div>
              <div class="header-right">{{ headerRight }}</div>
            </div>
          </div>
          <div class="page-content">
            <component :key="getComponentKey(index)" :is="getType(section.type)" :report-data="section.options" :scopeParams="scopeParams" :is-template="true" :is-template-edit="isTemplateEdit" :report-type="report_type" @resourceListHidden="(hidden) => handleResourceListHidden(index, hidden)" />
          </div>
          <div v-if="isPage && !isCoverPage(index)" class="page-footer">
            <div class="footer-content">
              <div class="footer-left">{{ footerLeft }}</div>
              <div class="footer-center">
                <span v-if="footerCenter" class="footer-center-text">{{ footerCenter }}</span>
                <span class="page-number">{{ getPageNumber(index) }} / {{ getTotalPages() }}</span>
              </div>
              <div class="footer-right">{{ footerRight }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/config/setting'
import { setLanguage } from '@/utils/common/cookie'
// import Navbar from '@/sections/Navbar'
import Header from './templates/Header.vue'
import ResourceOverview from './templates/ResourceOverview.vue'
import Footer from './templates/Footer.vue'
import BillOverview from './templates/BillOverview.vue'
import AccountBalance from './templates/AccountBalance.vue'
import ResourceMonitor from './templates/ResourceMonitor.vue'
import MonitorOverview from './templates/MonitorOverview.vue'
import MetricTable from './templates/MetricTable.vue'
import ResourceList from './templates/ResourceList.vue'
import Cover from './templates/Cover.vue'
import SuggestOverview from './templates/SuggestOverview.vue'

export default {
  name: 'CustomReport',
  components: {
    // Navbar,
    Header,
    ResourceOverview,
    Footer,
    BillOverview,
    AccountBalance,
    ResourceMonitor,
    MonitorOverview,
    MetricTable,
    ResourceList,
    Cover,
    SuggestOverview,
  },
  props: {
    templateList: {
      type: Array,
      default: () => [],
    },
    isTemplateEdit: {
      type: Boolean,
      default: false,
    },
    isPage: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'daily',
    },
    domainId: {
      type: String,
      default: undefined,
    },
    projectId: {
      type: String,
      default: undefined,
    },
    hideEmpty: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    const { project_id, domain_id, report_id, lang, scope, scope_id, report_type } = this.$route.query
    return {
      templates: this.templateList,
      report_id,
      // scope, lang, scope_id 为环境参数
      lang,
      scope_id,
      // scope, project_id, domain_id 为数据范围,需应用至每一个数据请求中
      project_id,
      domain_id,
      scope,
      report_type: report_type || this.type,
      // 页眉页脚内容
      headerLeft: '',
      headerCenter: '',
      headerRight: '',
      footerLeft: '',
      footerCenter: '',
      footerRight: '',
      hiddenSections: {}, // key: `${index}_${scope}_${project_id}_${domain_id}`
      hiddenEmptyData: true,
    }
  },
  computed: {
    ...mapGetters(['scope']),
    pageStyle () {
      return {
        backgroundColor: this.isPage ? '#ccc' : 'transparent',
      }
    },
    containerStyle () {
      return {
        boxShadow: this.isPage ? 'none' : '0 0 10px 0 rgba(0, 0, 0, 0.1)',
        margin: this.isPage ? '0 auto' : '0',
      }
    },
    scopeParams () {
      return {
        scope: this.scope,
        project_id: this.projectId || this.project_id,
        domain_id: this.domainId || this.domain_id,
      }
    },
    scopeParamsKey () {
      const { scope, project_id, domain_id } = this.scopeParams
      return [scope, project_id, domain_id].map(v => v ?? '').join('_')
    },
    hiddenEmpty () {
      if (this.isPage) {
        return this.hiddenEmptyData
      }
      return this.hideEmpty
    },
  },
  watch: {
    templateList: {
      handler (newVal) {
        this.templates = newVal
      },
    },
  },
  mounted () {
    let needReload = false
    // 恢复环境
    if (this.lang && this.lang !== setting.language) {
      setLanguage(this.lang)
      needReload = true
    }
    if (this.scope && this.scope_id && (this.$store.getters.scope !== this.scope || this.scope_id !== this.$store.getters.auth.info.projectId)) {
      this.reLogin(this.scope_id, this.scope)
    } else if (needReload) {
      window.location.reload()
    } else if (this.report_id) {
      this.$rM = new this.$Manager(this.report_type === 'month' ? 'month_reports' : 'daily_reports', 'v1')
      this.fetchReportData()
    }
  },
  methods: {
    getHiddenSectionKey (index) {
      return `${index}_${this.scopeParamsKey}`
    },
    handleResourceListHidden (index, hidden) {
      if (!this.hiddenEmpty) return
      const key = this.getHiddenSectionKey(index)
      if (hidden) {
        this.$set(this.hiddenSections, key, true)
      } else {
        this.$delete(this.hiddenSections, key)
      }
    },
    async reLogin (projectId, scope) {
      // this.reLogging = true
      try {
        await this.$store.dispatch('auth/login', {
          tenantId: projectId,
        })
        await this.$store.commit('auth/SET_SCOPE', scope)
        await this.$store.commit('auth/SET_TENANT', projectId)
        await this.$store.commit('auth/UPDATE_LOGGED_USERS', {
          key: this.$store.getters['auth/currentLoggedUserKey'],
          value: {
            tenant: projectId,
            scope,
          },
        })
        await this.$store.commit('auth/UPDATE_HISTORY_USERS', {
          key: this.$store.getters['auth/currentHistoryUserKey'],
          value: {
            tenant: projectId,
            scope,
          },
        })
        await this.$store.dispatch('scopedPolicy/get', {
          category: ['sub_hidden_menus'],
        })
        window.location.reload()
        return true
      } catch (error) {
        throw error
      } finally {
        // this.reLogging = false
      }
    },
    fetchReportData () {
      this.$rM.get({
        id: this.report_id,
      }).then(res => {
        this.hiddenEmptyData = res.data.hasOwnProperty('hide_empty') ? res.data.hide_empty : true
        this.templates = (res.data.templates || []).map(template => {
          return {
            ...template,
            options: {
              ...template.options,
              queryParams: {
                ...template.options.queryParams,
                project_id: this.project_id,
                domain_id: this.domain_id,
              },
            },
          }
        })
      })
    },
    getType (type) {
      return this.$options.components[type] || null
    },
    getComponentKey (index) {
      // 基于 section 的 index 和 scopeParams 生成唯一 key
      // 当 scopeParams 变化时，key 也会变化，从而触发组件重新挂载
      return `${index}_${this.scopeParamsKey}`
    },
    isCoverPage (index) {
      // 判断第一个页面是否是封面组件
      return index === 0 && this.templates[0]?.type === 'Cover'
    },
    getPageNumber (index) {
      // 计算当前页面在可见页面中的序号
      let visiblePageIndex = 0
      for (let i = 0; i <= index; i++) {
        if (!this.isSectionHidden(i)) {
          visiblePageIndex++
        }
      }
      return visiblePageIndex
    },
    getTotalPages () {
      // 总页数只包括可见的页面
      return this.templates.filter((section, index) => !this.isSectionHidden(index)).length
    },
    isSectionHidden (index) {
      if (!this.hiddenEmpty) return false
      return this.hiddenSections[this.getHiddenSectionKey(index)] === true
    },
  },
}
</script>

<style lang="less" scoped>
.custom-report-page {
  background-color: #ccc;
  width: 100%;
  height: auto !important;
  .custom-report-container {
    height: auto !important;
    width: 794px;
    margin: 0 auto;
    background-color: #fff;
    position: relative;
    // A4 纸标准打印边距：左右 50px
    padding: 0 50px;
    .a4-page {
      width: 100%;
      min-height: 1123px;
      background-color: #fff;
      margin-bottom: 20px;
      page-break-after: always;
      box-sizing: border-box;
      position: relative;
      &:last-child {
        margin-bottom: 0;
        page-break-after: auto;
      }
      .page-header {
        position: absolute;
        top: 0;
        left: -50px;
        right: -50px;
        height: 50px;
        background-color: #fff;
        z-index: 10;
        .header-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          padding: 0 50px;
          font-size: 12px;
          color: #666;
        }
      }
      .page-content {
        padding-top: 50px;
        padding-bottom: 50px;
        min-height: calc(1123px - 100px);
      }
      &.cover-page {
        .page-content {
          padding-top: 0;
          padding-bottom: 0;
          min-height: 1123px;
          .report-section-cover {
            min-height: 1123px;
          }
        }
      }
      .page-footer {
        position: absolute;
        bottom: 0;
        left: -50px;
        right: -50px;
        height: 50px;
        background-color: #fff;
        z-index: 10;
        .footer-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 100%;
          padding: 0 50px;
          font-size: 12px;
          color: #666;
          .footer-left,
          .footer-right {
            flex: 1;
          }
          .footer-center {
            flex: 1;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            gap: 4px;
            .footer-center-text {
              display: block;
            }
            .page-number {
              font-weight: 500;
              display: block;
            }
          }
        }
      }
    }
    ::v-deep {
      .report-section {
        padding: 20px 0;
      }
    }
  }
}
@media print {
  @page {
    size: A4;
    margin: 0; /* 打印时设置为无边距，边距通过样式设置 */
  }
  * {
    -webkit-print-color-adjust: exact !important;  /* Chrome, Safari */
    // color-adjust: exact !important;               /* 标准属性 */
    print-color-adjust: exact !important;         /* 新版属性 */
  }
  .custom-report-page {
    height: auto !important;
    background-color: transparent !important;
  }
}
</style>

<style>
#svg-sprite {
  display: none;
}
</style>
